// 目前主要用于处理pk对比
export interface ICar {
  carId: number
  carName: string
  brandId?: number
  brandName?: string
  seriesId?: number
  seriesName?: string
}

interface ITogglePkPanel {
  type: 'togglePk'
  payload?: boolean
}
interface IAddCarAction {
  type: 'addCar'
  payload: ICar
}
interface IRemoveCarAction {
  type: 'removeCar'
  payload: ICar['carId']
}
interface IClearCarAction {
  type: 'clearCars'
}
export type IAction =
  | IAddCarAction
  | IRemoveCarAction
  | IClearCarAction
  | ITogglePkPanel
export interface ISelectedCars {
  cars: ICar[]
  showPk: boolean
}
// const state = {
//   brand: {
//     param: 2,
//     text: '宝马'
//   }
// }
export function getInitState(): ISelectedCars {
  return {
    cars: fetchFromLocal(),
    showPk: false,
  }
}

export function reducer(state: ISelectedCars, action: IAction) {
  switch (action.type) {
  case 'addCar': {
    if (state.cars.find((item) => item.carId === action.payload.carId)) {
      return state
    }
    const cars = state.cars.concat(action.payload)
    persistent(cars)
    return {
      ...state,
      cars,
    }
  }
  case 'removeCar': {
    const cars = state.cars.filter((car) => car.carId !== action.payload)
    persistent(cars)
    return {
      ...state,
      cars,
    }
  }
  case 'clearCars':
    persistent([])
    return {
      ...state,
      cars: [],
    }
  case 'togglePk': {
    let showPk = !state.showPk
    console.log(action.payload)
    if (typeof action.payload === 'boolean') {
      showPk = action.payload
    }
    return {
      ...state,
      showPk,
    }
  }
  default:
    return getInitState()
  }
}
// 存储数据
function persistent(data: any) {
  try {
    window.localStorage.setItem('pk-list', JSON.stringify(data))
  } catch (err) {}
}
function fetchFromLocal(): ICar[] {
  if (typeof window === 'undefined') {
    return []
  }
  try {
    let data: any = window.localStorage.getItem('pk-list')
    if (data) {
      data = JSON.parse(data)
    }

    return (data as ICar[]) || []
  } catch (err) {
    return []
  }
}
